<template>
  <div
    class="local-lm--orders-tag"
    v-html="templateText"
  />
</template>

<script>
import { mixin } from '@/mixins'

export default {
  name: 'OrdersTag',
  mixins: [
    mixin.dates
  ],
  props: {
    orders: {
      default: ''
    },
    date: String,
    type: String
  },
  computed: {
    templateText () {
      if (this.orders.length > 1) {
        const output = this.orders.reduce((acc, order, index) => {
          return (index !== 0)
            ? acc + `, ${order}`
            : acc + `${order}`
        })

        return `${this.$t('OrdersTag.manyOrders', { orders: output })}`
      }

      if (this.type === 'RESCHEDULE_DATE_TIME') return `${this.$t('OrdersTag.oneOrder', { orders: this.orders })} ${this.$t('OrdersTag.collectedTag', {date: this.stripHour(this.date)})}`
      if (this.type === 'SHOW_UPLOAD_POD') return `${this.$t('OrdersTag.oneOrder', { orders: this.orders })}`

      return `${this.$t('OrdersTag.oneOrder', { orders: this.orders })} ${this.$t('OrdersTag.deliveryTag', {date: this.stripHour(this.date)})}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OrdersTag.vue